export const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  gprcUrl: process.env.REACT_APP_GPRC_URL,
  downloadUrl: process.env.REACT_APP_DOWNLOAD_URL,
  appSubdomain: process.env.REACT_APP_SUBDOMAIN,
  maxFileSizeUpload: 1000000,
  maxCommentCount:15
};



// WEBPACK FOOTER //
// ./src/config/config.tsx